/* eslint-disable react/prop-types */
import { observer } from "mobx-react";
import Footer from "@/components/footer/Footer";
import Header from "@/components/header/Header";
import SectionsRenderer from '@/components/sections/SectionsRenderer';
import DefaultPageContent from '@/components/page-templates/DefaultPageContent';
import Link from '@/components/common/Link';
import { replaceBackendWithFrontendUrl } from '@/utils/misc';
const ContentPage = observer(({
  pageData,
  products,
  crossSellProducts,
  sideMenuData,
}) => {
  const hasSideMenu = pageData.acf?.enable_side_menu && sideMenuData?.items?.length > 0;

  return (
    <>
      <Header title={pageData.title?.rendered} />
      <main className="pt-[9rem] pd:mt-0">
        {hasSideMenu ? (
          <div className="container mx-auto px-4 flex gap-8 mt-[2rem]">
            {/* Side Menu */}
            <aside className="w-64 shrink-0">
              <nav className="sticky top-24">
                <ul className="space-y-2">
                  {sideMenuData.items.map((item) => (
                    <li key={item.ID}>
                      <Link
                        href={replaceBackendWithFrontendUrl(item.url)}
                        className="block p-2 hover:bg-gray-100 rounded transition-colors text-primary-studio"
                      >
                        {item.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </nav>
            </aside>

            {/* Main Content */}
            <div className="flex-1">
              {!pageData.acf?.sections || pageData.acf.sections.length === 0 ? (
                <DefaultPageContent pageData={pageData} />
              ) : (
                <SectionsRenderer sections={pageData.acf.sections} products={products} crossSellProducts={crossSellProducts} />
              )}
            </div>
          </div>
        ) : (
          // Regular content without side menu
          <>
            {!pageData.acf?.sections || pageData.acf.sections.length === 0 ? (
              <DefaultPageContent pageData={pageData} />
            ) : (
              <SectionsRenderer sections={pageData.acf.sections} products={products} crossSellProducts={crossSellProducts} />
            )}
          </>
        )}
      </main>
      <Footer />
    </>
  );
});

export default ContentPage;